module.exports = __webpack_public_path__ + "media/images/flags/4x3/nic-d6158b8ec51f553752b611ed41d66a16.svg";